import React from "react";
import { Link } from "react-router-dom";
import Logged from "../Components/Profile.jsx";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { Loader } from "react-clip-loader";
import "react-clip-loader/dist/index.css";
import { url } from "../utils/url";
import axios from "axios";
import ExplorePost from "../Components/ExplorePost";
import SEO from "../Components/SEO";
import SidebarNav from "../Components/navigation/SidebarNav";

// import EditProfile from "../Components/EditProfile";
function Explore() {
  const [explores, setexplores] = React.useState([]);
  const [ended, setended] = React.useState([]);
  const [loading, setloading] = React.useState(false);
  const [page, setpage] = React.useState(1);

  const { user, mode } = React.useContext(UserContext);
  // setting the theme
  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  const loadExplores = async () => {
    // console.log("load explores", page);
    if (!loading) {
      setloading(true);
      let tempExplores = [];
      let tempEnded = ended;
      let tempPage = page;
      await axios
        .get(`${url}/api/explore/posts?page=${page}`, {
          params: {
            seenExplores: JSON.stringify(explores.map((post) => post._id)),
          },
        })
        .then((res) => {
          let response = res.data?.posts;
          tempExplores = [...explores, ...response.docs];
          tempEnded = !response.hasNextPage;
          tempPage = response.nextPage;
        });
      if (tempExplores) {
        setexplores(tempExplores);
        setended(tempEnded || false);
        setpage(tempPage);
      }
      setloading(false);
    }
  };

  const bottomScrollCallback = () => {
    // console.log("Scrolled to bottom");
    if (!loading && explores.length > 0 && !ended) {
      // console.log("Loading new explores...");
      loadExplores();
    }
  };

  useBottomScrollListener(bottomScrollCallback, {
    offset: 800,
    debounce: 0,
    triggerOnNoScroll: true,
  });

  React.useEffect(() => {
    loadExplores();
    // eslint-disable-next-line
  }, []);

  // console.log(explores);

  return (
    <>
      <SEO title={`Explore`} description="Explore Outside Twika"></SEO>
      <div
        className={(dark && "darkmode") + " flex justify-center w-full"}
        id="posts__container"
      >
           <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
           <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
              <SidebarNav />
              </div>
              </div>
            <div className="col-span-6">
            {user.token ? (
              <>
                {explores.map((explore) => {
                  return (
                    <ExplorePost data={explore} key={explore._id}></ExplorePost>
                  );
                })}
                {explores.length > 0 && (
                  <div className="w-full flex justify-center mb-3">
                    {loading ? (
                      <Loader small={true}></Loader>
                    ) : (
                      <Link
                        to="#"
                        className="bg-fire text-white p-3 rounded hover:opacity-50 hover:text-white"
                        onClick={() => !loading && loadExplores()}
                      >
                        {loading ? "Loading..." : "Load More"}
                      </Link>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div>
                {explores.length > 0 ? (
                  <ExplorePost data={explores[0]}></ExplorePost>
                ) : (
                  <ExplorePost data={explores[0]}></ExplorePost>
                )}
                <div className="w-full flex justify-center">
                  <Link
                    to="/login"
                    className="bg-fire text-white p-3 rounded hover:opacity-50 hover:text-white"
                  >
                    View More
                  </Link>
                </div>
              </div>
            )}
          </div>
          </div>

         
          <div className="lg:col-span-5">
            {user.token ? <Logged /> : <TryLogin />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Explore;
